module.exports = __webpack_public_path__ + "img/17_61.b4c533f5.png";